import {
  shape, arrayOf, string, number, any,
} from 'prop-types';

export const encargoType = shape({
  cobros: arrayOf(any).isRequired,
  id: string.isRequired,
  paciente_id: any,
  promocionInfo: any,
  tienda_id: number.isRequired,
  total: number.isRequired,
});

export const encargosType = arrayOf(encargoType);
